import {withStyles} from "@material-ui/core";
import {colors} from "../../../../../shared/colors";
import StepConnector from "@material-ui/core/StepConnector";

export const StepperConnector = withStyles({
    alternativeLabel: {
        top: 22,
    },
    active: {
        '& $line': {
            backgroundColor: colors.californiaCyan
        },
    },
    completed: {
        '& $line': {
            backgroundColor: colors.californiaCyan
        },
    },
    disabled: {
        '& $line': {
            backgroundColor: "#ccc"
        },
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
    },
})(StepConnector);
